import { useState } from "react";
import {
  ResponseGetNoticeResponse,
  NoticeApi,
  RequestCreateNoticeRequest,
  NoticeCreateNoticePostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiCreateNotice = () => {
  const [noticeList, setNoticeList] = useState<
    ResponseGetNoticeResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const createNotice = async (req: RequestCreateNoticeRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: NoticeCreateNoticePostRequest = {
        req,
      };
      const api = new NoticeApi(config);
      const response = await api.noticeCreateNoticePost(request);
      setNoticeList(response);
      return response;
    } catch (err: any) {
      setError("お知らせの登録に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { createNotice, noticeList, error, isLoading };
};
